<div
    class="badge"
    [class.header]="headerStyle"
    fxLayout="row"
    fxLayoutAlign="start center"
    fxLayoutGap="8px"
    [dialogLink]="headerStyle ? undefined : ['alert', alert?.id]"
>
    <!-- session icon -->
    <mat-icon [svgIcon]="iconToUse.svgIcon" [class]="iconToUse.class"></mat-icon>

    <!-- ev and date info -->
    <div fxFlex class="info" fxLayout="column" [matTooltip]="alert?.title">
        <label>{{ alert?.title }}</label>
        <ng-container *ngIf="displayStation">
            <div fxLayout="row">
                <span class="station" fxFlex>{{ alert?.stationName }}</span>
                <span class="date">{{ alert?.timestamp | csmsDuration: { ago: true } }}</span>
            </div>
        </ng-container>
        <ng-container *ngIf="!displayStation">
            <span class="date">{{
                alert?.timestamp
                    | adjustUtcDate
                        : { format: 'DD.MM.yyyy HH:mm', time: (currentTime$ | async), showUtcTimeLabel: true }
            }}</span>
        </ng-container>
    </div>
</div>
